import ManageBeneficaiaries from './ManageBeneficiariesContainer';

export default ManageBeneficaiaries;
